module.exports = __webpack_public_path__ + "resources/img/member_type_personal.22ed5a2bbed626fc98133e957e5bc8c2.png";